
































































































import { isEqual } from 'lodash'
import { Bind, Debounce } from 'lodash-decorators'
import { Component, Mixins } from 'vue-property-decorator'

import Select from '@/components/_uikit/controls/Select.vue'
import TextInput from '@/components/_uikit/controls/TextInput.vue'
import TableFooter from '@/components/_uikit/TableFooter.vue'
import RowTable from '@/components/_uikit/RowTable.vue'
import Tag from '@/components/_uikit/Tag.vue'
import DictionaryModule from '@/store/modules/dictionary'
import SupportModule from '@/store/modules/support'
import { ISupportFilter, ISupportFilterType, TicketShortResource } from '@/store/types'
import { tableFooterOptions } from '@/utils/constants'
import PermissionsMixin from '@/mixins/PermissionsMixin'
import ScreenMixin from '@/mixins/ScreenMixin'
import AuthModule from '@/store/modules/auth'

@Component({
  components: {
    Select,
    TableFooter,
    Tag,
    TextInput,
    RowTable,
  },
})
export default class SupportTable extends Mixins(PermissionsMixin, ScreenMixin) {
  private footerOptions = tableFooterOptions

  private get isManagerView () {
    return this.$route.name === 'manager.support.tickets'
  }

  private get filter () {
    return SupportModule.ticketsFilter
  }

  private set filter (filter: ISupportFilter) {
    if (!isEqual(filter, this.filter) || this.tickets.length === 0) {
      SupportModule.setTicketsFilter(filter)
      this.fetchTickets()
    }
  }

  private get statuses () {
    return DictionaryModule.ticketStatuses
  }

  private hasNewItems(item: TicketShortResource) {
    if (item.hasNewMessages) {
      return 'support__ticket has-new-messages'
    }
    return 'support__ticket'
  }

  private get headers () {
    return [
      { text: '', value: 'new', width: '10px' },
      { text: '#', value: 'id', width: '35px' },
      { text: 'Автор', value: 'author' },
      { text: 'Тема', value: 'topic', width: '1.5fr' },
      { text: 'Дата создания', value: 'createdAt', width: '120px' },
      { text: 'Последний ответ', value: 'lastAnsweredAt', width: '120px' },
      { text: 'Статус', value: 'status', width: '85px' },
    ]
  }

  private get tickets () {
    return SupportModule.tickets.data
  }

  private get pagination () {
    return SupportModule.tickets.meta
  }

  private get isLocalTimezone() {
    return AuthModule.isLocalTimezone
  }

  private mounted () {
    this.$bus.$on('updateTicketsList', this.updateTicketsList)

    if (!this.isManagerView) {
      this.filter = {
        ...this.filter,
        myRequest: 1,
      }
    } else if (this.hasPermission(this.Permission.SUPPORT_ANSWER)) {
      this.filter = {
        ...this.filter,
        myRequest: 0,
      }
    }
  }

  private destroyed() {
    this.$bus.$off('updateTicketsList', this.updateTicketsList as any)
  }

  @Bind
  @Debounce(300)
  private updateTicketsList() {
    SupportModule.fetchTickets(false)
      .catch(this.notifyError)
  }

  @Bind
  @Debounce(300)
  private fetchTickets () {
    SupportModule.fetchTickets()
      .catch(this.notifyError)
  }

  private handleFilter (field: ISupportFilterType, value: never) {
    this.filter = {
      ...this.filter,
      [field]: value,
      page: 1,
    }

    this.fetchTickets()
  }

  private handleRowClick (ticket: TicketShortResource) {
    this.$router.push({
      name: this.$route.name === 'manager.support.tickets' ? 'manager.support.item' : 'master.support.item',
      params: { ticketID: ticket.id.toString() },
    })
  }

  private handleNewTicket () {
    this.$router.push({ name: this.$route.name === 'manager.support.tickets' ? 'manager.support.new' : 'master.support.new' })
  }
}
